export class MediaImageRepositoryPathAdapter {
  adapt(projectId: string): string {
    return projectId;
  }

  adaptForClearing(projectId: string): string {
    return `${projectId}`;
  }
}

export class EditingProjectMediaImageRepositoryPathAdapter extends MediaImageRepositoryPathAdapter {
  adapt(projectId: string): string {
    return `/editing-project/${projectId}`;
  }
  adaptForClearing(projectId: string): string {
    return `/editing-project`;
  }
}

export class SavedProjectMediaImagePathAdapter extends MediaImageRepositoryPathAdapter {
  adapt(projectId: string): string {
    return `/projects/${projectId}`;
  }
  adaptForClearing(projectId: string): string {
    return `/projects/${projectId}`;
  }
}